module.exports = __webpack_public_path__ + "static/media/digital-solutions.dca7e38f.svg";